import React, { useRef, useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import AccessControl from '../../AccessControl';
import permissions from '../../permissionsList';
import DocumentsAndImages from './documentsandimages/Category';
import AddCategory from './documentsandimages/AddCategory';
import CategoryTable from './documentsandimages/CategoryTable';
import FilePreview from './documentsandimages/FilePreview';
import AlertGroupsView from './alertGroups/AlertGroupsView';

export function UnconnectedDocumentsAndImages() {
  const location = useLocation();
  const previousLocation = useRef(location);
  

  if (
    location &&
    location.state &&
    location.state.modal &&
    window.history.state && window.history.state.idx > 0 // Check if we navigated back
  ) {
    if (
      location.pathname === '/administration/AddCategory/' 
      
    ) {
      previousLocation.current = { pathname: '/administration/DocumentsAndImages/' };
    }
  }

  useEffect(() => {
    if (location) {
      if (location.state && location.state.modal) {
        previousLocation.current = { pathname: '/administration/DocumentsAndImages/' };
      } else {
        previousLocation.current = location;
      }
    }
  }, [location]);

  let isModal = false;
  if (location && location.state && location.state.modal) {
    isModal = true;
  }

  return (
    <AccessControl
       data-test="access-control"
       feature={permissions.static.navBar.administration}
       permissionMessage={true}>
      <React.Fragment>
        {/* The switch is used to set the background to display underneath the overlay component. It checks to see if the url being loaded involves a modal and uses the route found in the previousLocation ref to set the contents of the switch */}
        <Routes location={isModal ? previousLocation.current : location}>
          <Route 
            path="/"
            element={<DocumentsAndImages />}
          />
          <Route 
            path="/DocumentsAndImages/"
            element={<DocumentsAndImages />}
          />
           <Route 
            path="/AddCategory/"
            element={<AddCategory onCancel={() => window.history.back()} />}
          />
             <Route 
            path="/FilePreview/"
            element={<FilePreview />}
          />
             <Route 
            path="/CategoryTable/"
            element={<CategoryTable />}
          />
            <Route
            path="/AlertGroups/"
            element={<AlertGroupsView />}
           />

        </Routes>
      </React.Fragment>
    </AccessControl>
  );
}
export const DocumentsandimagesWithRouter = connect()(UnconnectedDocumentsAndImages);
export default connect()(UnconnectedDocumentsAndImages);